import { render, staticRenderFns } from "./deleteUserDialog.vue?vue&type=template&id=753cc34b&scoped=true"
import script from "./deleteUserDialog.vue?vue&type=script&lang=ts"
export * from "./deleteUserDialog.vue?vue&type=script&lang=ts"
import style0 from "./deleteUserDialog.vue?vue&type=style&index=0&id=753cc34b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753cc34b",
  null
  
)

export default component.exports